import { useEffect, useState } from "react";
import { Modal, Spinner } from "react-bootstrap";



export function YoutubeVideoModal({show, onHide, embedUrl}) {
    const [loading, setLoading] = useState(true);
    const stopLoading = () => setLoading(false);
    const handleHideModal = ()=> {
        setLoading(true);
        onHide?.();
    }

    return (
        <Modal
        size="xl"
        show={show}
        onHide={handleHideModal}
        contentClassName="border-0 bg-transparent "
        className="mds-modal pt-5 "
        centered
      >
        <Modal.Body className="p-0  mds-rounded ">
          <style>
            {`.modal-backdrop.show {
              opacity : 0.85 !important;
            }`}
          </style>
          <div className=" position-relative">
          <div style={{zIndex : "2"}} class="position-absolute top-0 start-100 translate-middle">
            <button onClick={handleHideModal} className="btn-close p-2 rounded-circle mds-bg-primary-muted"></button>
          </div>
          {loading ?
          <div class="position-absolute top-50 start-50 translate-middle">
          <Spinner className="mds-bg-primary mx-auto" animation="grow" />
          </div>
          : ""}
          
          <div class="video-container mds-rounded overflow-hidden  ">
          <iframe
          className="mds-modal-shadow"
              style={{ width: "100%" }}
              src={embedUrl}
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
              onLoad={stopLoading}
              
            ></iframe>
           
          </div>

          </div>
        </Modal.Body>
      </Modal>
    )
}

export default YoutubeVideoModal;